import React from 'react';
import { InterPoint } from '@saviynt/common';
import { Box, Button, Icon, Typography } from '@saviynt/design-system';

import { CF_NEU_BLD, CF_SEC_MED } from '../../../../../constants';
import { useInvertedLocalize } from '../../../../../hooks';
import { type ImpactSummaryTypes } from '../../../../../types';
import { MOCK_REMEDIATION_FUNCTION } from '../../mockRemediateList';

import './SodRemediateFuctionSelect.css';

interface SodRemediateFuctionSelectProps {
  isSelectingFunction: boolean;
  setSelectedFunction: (func: ImpactSummaryTypes) => void;
}

/**
 * TODO:
 * - Write description
 * - SodRemediateFuctionSelect-itemTitle truncation or smaller width overflow
 */
function SodRemediateFuctionSelect({
  isSelectingFunction,
  setSelectedFunction,
}: SodRemediateFuctionSelectProps) {
  const l = useInvertedLocalize();

  return (
    <Box tabIndex={-1} className='SodRemediateFuctionSelect'>
      {MOCK_REMEDIATION_FUNCTION.map((func, index) => (
        <Box key={func.id} className='SodRemediateFuctionSelect-functionItem'>
          {/* Function Title */}
          <Box className='SodRemediateFuctionSelect-itemTitle'>
            <Typography kind='h3' color={CF_NEU_BLD} isNoWrap>
              {`To remediate function ${index + 1}`}
            </Typography>
            <Typography kind='h3' color={CF_SEC_MED} isNoWrap>
              (OracleCloud_FUN_Enter Journal)
            </Typography>
            <Typography kind='h3' color={CF_NEU_BLD} isNoWrap>
              {`of this violation, revoke the following ${func.entitlements.length} access:`}
            </Typography>
          </Box>
          {/* Rows */}
          <Box className='SodRemediateFuctionSelect-innerRowGroup'>
            {func.entitlements.map((row) => (
              <Box key={row.id} className='SodRemediateFuctionSelect-innerRow'>
                {/* Leading */}
                <Box className='SodRemediateFuctionSelect-rowLeading'>
                  <Icon kind='Entitlement' color={CF_SEC_MED} />
                </Box>
                {/* Main Row Content */}
                <Box className='SodRemediateFuctionSelect-rowMain'>
                  <Box className='SodRemediateFuctionSelect-rowTop'>
                    <Typography kind='body3' color={CF_SEC_MED}>
                      Assigned Entitlement
                    </Typography>
                    <InterPoint color='secondaryMedium' font='body3' />
                    <Typography kind='body3' color={CF_SEC_MED}>
                      Responsibility
                    </Typography>
                  </Box>
                  <Box className='SodRemediateFuctionSelect-rowBottom'>
                    <Typography kind='h3' color={CF_NEU_BLD}>
                      {row.title}
                    </Typography>
                    <Typography kind='body3' color={CF_SEC_MED}>
                      {`(${row.subtitle})`}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
          {/* Impact selection */}
          <Box className='SodRemediateFuctionSelect-impactSelectionWrapper'>
            <Button
              onClick={() => {
                setSelectedFunction(func);
              }}
              isDisabled={!isSelectingFunction}
              rightIcon={<Icon kind='ArrowRight' />}>
              {l('View Impact')}
            </Button>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default SodRemediateFuctionSelect;
